// Suomalaiset esitysmuodot yhdessä paikassa: desimaalipilkku, 24 h kello
// ja päivämäärä muodossa 10.10.2026. Aikavyöhyke on Europe/Helsinki,
// jotta näkymä vastaa palvelimen paikallista päivää.

const TZ = "Europe/Helsinki";

export const km = (meters) => `${(meters / 1000).toLocaleString("fi-FI", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} km`;
export const kmValue = (kmNumber) => `${kmNumber.toLocaleString("fi-FI", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} km`;

export const clock = (unixSeconds) =>
  new Date(unixSeconds * 1000).toLocaleTimeString("fi-FI", { hour: "2-digit", minute: "2-digit", timeZone: TZ });

export const day = (unixSeconds) =>
  new Date(unixSeconds * 1000).toLocaleDateString("fi-FI", { day: "numeric", month: "numeric", year: "numeric", timeZone: TZ });

export const dayFromIso = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  return `${d}.${m}.${y}`;
};

/** Esim. "Lauantai 10.10." – viikonpäivä erikseen, jottei tule taivutettua muotoa "lauantaina". */
export function weekdayDay(unixSeconds) {
  const date = new Date(unixSeconds * 1000);
  const weekday = date.toLocaleDateString("fi-FI", { weekday: "long", timeZone: TZ });
  const dm = date.toLocaleDateString("fi-FI", { day: "numeric", month: "numeric", timeZone: TZ });
  return `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)} ${dm}`;
}

/** Kestolaskuri tallennuksen aikana: 4:05 tai 1 h 05 min. */
export function duration(seconds) {
  const s = Math.max(0, Math.round(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return h ? `${h} h ${String(m).padStart(2, "0")} min` : `${m}:${String(sec).padStart(2, "0")}`;
}

export const points = (n) => `${n > 0 ? "+" : ""}${n.toLocaleString("fi-FI")}`;

/** Paikallinen päivä ISO-muodossa (YYYY-MM-DD) Helsingin ajassa. */
export function todayIso() {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
  return parts; // en-CA tuottaa valmiiksi muodon 2026-10-10
}

/** Kesto lauseessa: "33 min" tai "1 h 05 min". */
export function durationText(seconds) {
  const m = Math.round(Math.max(0, seconds) / 60);
  return m < 60 ? `${m} min` : `${Math.floor(m / 60)} h ${String(m % 60).padStart(2, "0")} min`;
}
